// @flow
import {type Action as UserActions, USER_SET_LOGGED_IN} from '../actions/user';

const initialState = {
    isLoggedIn: false
};

export type State = {
    isLoggedIn: boolean
};

export default function reducer(
    state: State = initialState,
    action: UserActions
): State {
    switch (action.type) {
        case USER_SET_LOGGED_IN:
            return action.payload;
        default:
            (action: empty); // eslint-disable-line no-unused-expressions
            return state;
    }
}
